import { Image, Modal, Space } from 'antd';
import React, { useState } from 'react';
import { useMedia } from 'react-use';
import { WrongIcon } from '../../../../../../assets/svg';
import {
  BREAKPOINTS,
  GA_EVENT,
  GA_LABEL,
} from '../../../../../../common/constants';
import { Event } from '../../../../../../common/trackEvents';

const RegisterCommentModal = ({ showModal, setShowModal, comment }) => {
  const commentText = comment?.commentText;
  const assetUrls = comment?.assetUrls || [];
  const [isVisible, setIsVisible] = useState(false);
  const [previewImageKey, setPreviewImageKey] = useState('');
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  const getPhotos = (photos, imageId) => {
    return photos?.length ? (
      <Image.PreviewGroup
        preview={{
          visible: imageId === previewImageKey && isVisible,
          onVisibleChange: (visible) => {
            setIsVisible(visible);
            if (visible) {
              Event(GA_EVENT.OPENED_IMAGE_VIEWER, {
                label: GA_LABEL.OPENED_IMAGE_VIEWER,
                // eslint-disable-next-line no-undef
                pathname: window?.location?.href,
              });
            }
          },
        }}
      >
        <Space className="image-preview-wrapper">
          {React.Children.map(photos, (photo) => (
            <Image
              src={photo}
              alt="logo"
              height={isDesktopViewport ? '64px' : '32px'}
              width={isDesktopViewport ? '64px' : '32px'}
              onClick={() => setPreviewImageKey(imageId)}
            />
          ))}
          {photos?.length - 1 > 0 && (
            <div
              className="pointer extra-count"
              onClick={() => {
                setIsVisible(true);
                setPreviewImageKey(imageId);
              }}
            >{`+ ${photos?.length - 1}`}</div>
          )}
        </Space>
      </Image.PreviewGroup>
    ) : (
      '-'
    );
  };

  const renderBody = () => {
    return (
      <div className="m-10">
        {commentText && (
          <div className="d-flex">
            <div className="text-no-break">
              <b>Comment: </b>
            </div>
            <div className="ml-5 text-break">{commentText}</div>
          </div>
        )}
        {assetUrls?.length > 0 && (
          <>
            <div className="mt-10 mb-10">
              <b>Images:</b>
            </div>
            <div className="comment-img-wrapper">
              {getPhotos(assetUrls, 'register-comment')}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <Modal
      maskClosable={false}
      open={showModal}
      onCancel={() => setShowModal(false)}
      footer={false}
      closeIcon={<WrongIcon />}
    >
      <h2 id="register-comment-title">View Comment</h2>
      <div id="register-comment-body" className="comment-modal-body">
        {renderBody()}
      </div>
    </Modal>
  );
};

export default RegisterCommentModal;
